"use client";

import React, { Suspense, useEffect, useRef } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";
import AboutMap from "./AboutMap";

gsap.registerPlugin(ScrollTrigger);

export default function AboutContiner({
  data,
  video,
}: {
  data: any;
  video?: boolean;
}) {
  const videoRef: any = useRef(null);
  const videoComponentRef: any = useRef(null);

  useEffect(() => {
    const videoElement = videoRef.current;
    const videoComponent = videoComponentRef.current.children[0];
    videoComponent.pause();

    const videoPlayTl = gsap.timeline({
      scrollTrigger: {
        trigger: videoComponent,
        start: "center 80%",
        end: "bottom 20%",
        scrub: 1,
        markers: false,
        pin: false,
        pinSpacing: false,
        onEnter: () => {
          videoComponent.play();
        },
        onLeave: () => {
          if (videoComponent && videoComponent.pause) {
            videoComponent.pause();
          }
        },
        onEnterBack: () => {
          if (videoComponent && videoComponent.play) {
            videoComponent.play();
          }
        },
        onLeaveBack: () => {
          if (videoComponent && videoComponent.pause) {
            videoComponent.pause();
          }
        },
      },
    });

    const videoTl = gsap.timeline({
      scrollTrigger: {
        trigger: videoElement,
        start: "center 80%",
        end: "top top",
        scrub: 1,
        markers: false,
        pin: false,
        pinSpacing: false,
      },
    });

    videoTl.to(videoElement, {
      scale: 0.8,
      borderRadius: "16px",
      onComplete: () => {
        ScrollTrigger.refresh();
      },
    });

    return () => {
      videoTl.kill(); // Clean up animation
    };
  }, []);

  // useEffect(() => {
  //     const videoComponent = videoComponentRef.current.children[0];

  //     const observer = new IntersectionObserver(
  //         (entries) => {
  //             entries.forEach((entry) => {
  //                 if (entry.isIntersecting) {
  //                     videoComponent.play();
  //                 } else {
  //                     videoComponent.pause();
  //                 }
  //             });
  //         },
  //         { threshold: 1.0 } // The video will play when the whole component is in view
  //     );

  //     observer.observe(videoComponent);

  //     return () => {
  //         observer.disconnect(); // Clean up observer
  //     };
  // }, []);

  return (
    <section className="relative bg-midPurple px-0 lg:pt-[5.25vw] ">
      {video && (
        <div
          className="relative -top-20 md:top-0 -mb-[6.25rem] md:-mb-[30px] md:scale-[0.75] scale-[0.9] origin-center rounded-[2rem] md:rounded-[4rem] overflow-clip md:-mt-[20vw] aspect-video"
          ref={videoRef}
        >
          <div
            className="pointer-events-none w-full h-full"
            ref={videoComponentRef}
          >
            <Suspense fallback={<>Loading ...</>}>
              {/* <VideoComponent
                                data={data.video.video.data.attributes.url}
                            /> */}
              <video
                src={
                  process.env.NEXT_PUBLIC_STRAPI_API_URL +
                  data.video.url
                }
                width={1920}
                height={1080}
                className="w-full h-full object-contain aspect-video"
                autoPlay
                loop
                playsInline
                muted
                preload="none"
              ></video>
            </Suspense>

            {/* <iframe
                            width="1920"
                            height="1080"
                            src="https://www.youtube.com/embed/zNI2_6CNy7E?autoplay=1&mute=1&controls=0&loop=1&playlist=zNI2_6CNy7E"
                            title="Kingdom Digital 2024 Showreel"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            className="w-full h-full object-contain"
                            loading="lazy"
                        ></iframe> */}
          </div>
        </div>
      )}
      {/* <AboutHumanising data={data.about} /> */}
      <AboutMap data={data.aboutBanner} />
      {/* <BottomCurves
                color={data.waveBgColor.waveBgColor}
                direction={"right"}
            /> */}
      {/* <BottomCurves color={data.waveBgColor} direction={"left"} /> */}
    </section>
  );
}
